module.exports = __webpack_public_path__ + "static/ride-spot-logo-a92c0df5201d1452c28dbf2e30756ef2.png";